import { render, staticRenderFns } from "./CopyRouteWrapper.vue?vue&type=template&id=588193c7&scoped=true"
import script from "./CopyRouteWrapper.vue?vue&type=script&lang=ts"
export * from "./CopyRouteWrapper.vue?vue&type=script&lang=ts"
import style0 from "./CopyRouteWrapper.vue?vue&type=style&index=0&id=588193c7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588193c7",
  null
  
)

export default component.exports